

export default function ViewDividerSmall() {

  return (
    <>
    <div className="py-2"></div>
    </>
  )
}